import { InputLabel, styled } from '@/theme/index';

export const StyledImage = styled('img')(({ theme }) => ({
  width: '100%',
  borderRadius: theme.shape.borderRadius,
  objectFit: 'cover',
  backgroundColor: theme.palette.grey[200],
}));

export const StyledInputLabel = styled(InputLabel)(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.text.primary,
  marginBottom: theme.spacing(0.75),
}));
